module.exports = __webpack_public_path__ + "img/d13.5b80521e.jpg";